import { DECORATION_ELEMENT } from '../constants/editable-elements';
import hasNodeContent from '../verifiers/has-node-content';

const removeEmptyDecorations = (element) => {
  const decorations = [...element.querySelectorAll(DECORATION_ELEMENT)];

  decorations.forEach((decoration) => {
    if (decoration && !hasNodeContent(decoration)) {
      decoration.remove();
    }
  });
};

export default removeEmptyDecorations;
